var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 7.875H10.125V0.375C10.125 0.1875 9.9375 0 9.75 0H8.25C8.01562 0 7.875 0.1875 7.875 0.375V7.875H0.375C0.140625 7.875 0 8.0625 0 8.25V9.75C0 9.98438 0.140625 10.125 0.375 10.125H7.875V17.625C7.875 17.8594 8.01562 18 8.25 18H9.75C9.9375 18 10.125 17.8594 10.125 17.625V10.125H17.625C17.8125 10.125 18 9.98438 18 9.75V8.25C18 8.0625 17.8125 7.875 17.625 7.875Z",
    fill: "#0069D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.12989845.svg";
export { ForwardRef as ReactComponent };